/**
 *
 * @module adInsertionStrategy
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef AdInsertionStrategy
 * @type {Object}
 * @since 3.0.0
 * @desc Defines the ad insertion strategy types
 * @example AdInsertionStrategy.CSAI // 'CSAI'
 *
 * @property {String} NONE - Ad tags will not be provided in the playlist. Ads will not play (slate only).
 * @property {String} CSAI - Ad tags will be provided in the playlist. The client
 * is expected to process tags and present ads.
 * @property {String} SSAI - Ad tags will not be provided in the playlist. Ads will be stitched into the main stream.
 *
 */

/**
 *
 * @enum
 * @type {AdInsertionStrategy}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    NONE: null,
    /**
     *
     * @access public
     * @type {String}
     * @desc insertion strategy used for client side ad insertion.
     *
     */
    CSAI: null,
    /**
     *
     * @access public
     * @type {String}
     * @desc insertion strategy used for server side ad insertion.
     *
     */
    SSAI: null
});



// WEBPACK FOOTER //
// ./src/media/adInsertionStrategy.js